import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

export function useRole() {
  const { user } = useContext(AuthContext);
  const roles = user?.roles ?? [];
  return {
    isAdmin: roles.includes("Admin"),
    isTeacher: roles.includes("Teacher"),
  };
}
